import Vue from "vue";
import Vuex from "vuex";
import acl from "./modules/login/acl";
import credit from "./modules/client/credit/credit";
import buyer from "./modules/client/payment/buyer";
import buttons from "./modules/buttons/buttons";
import wallet from "./modules/client/wallet/wallet";
import walletEnterprise from "./modules/entity/walletEnterprise/walletEnterprise";
import config from "./modules/config/config";
import ent from "./modules/config/enterprise/configEnterprise";
import client from "./modules/client/client";
import drawer from "./modules/drawer/drawer";
import getEntity from "./modules/entity/entity";
import category from "./modules/entity/category/category";
import product from "./modules/entity/category/product";
import displayProducts from "./modules/client/products/displayProducts";
import userProfile from "./modules/client/profile/userProfile";
import messageClient from "./modules/client/message/messageClient";
import commonBase from "./modules/ping/commonBase";
import displayCTransactions from "./modules/client/transactions/displayCTransactions";
import entityProfile from "@/store/modules/entity/profile/entityProfile";
import displayETransactions from "@/store/modules/entity/transactions/displayETransactions";
import invoice from "@/store/modules/entity/invoice/invoice";
import report from "@/store/modules/entity/report/report";
import message from "@/store/modules/entity/message/message";
import receipt from "@/store/modules/client/receipt/receipt";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    acl,
    credit,
    buyer,
    buttons,
    wallet,
    walletEnterprise,
    config,
    client,
    drawer,
    ent,
    getEntity,
    category,
    product,
    displayProducts,
    userProfile,
    messageClient,
    commonBase,
    displayCTransactions,
    entityProfile,
    displayETransactions,
    invoice,
    report,
    message,
      receipt
  }
});
